import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { useCurrentUser } from "APP_ROOT/hooks";
import Form from "./Form";

export default function EditBilling({ open, close, company }) {
  if (company.billing_address) {
    company.billing_address.region = company.region;
  }

  company.locations = useCurrentUser().locations.map(l => {
    const quickbooksVendor = company.quickbooks_vendor[l.id] || {};

    return { id: l.id, quickbooks_vendor: quickbooksVendor };
  });

  return (
    <Modal open={open} close={close}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Company Billing Information</h4>
      </Header>
      <Form
        company={company}
        close={close}
        initialValues={company}
        enableReinitialize
      />
    </Modal>
  );
}

EditBilling.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  company: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/EditBilling/EditBilling.jsx